// extracted by mini-css-extract-plugin
export default {"root":"MultipleModalAdditionalContent_root__owmbG","placeHolderShimmer":"MultipleModalAdditionalContent_placeHolderShimmer__mRsO8"};